import { createLogic } from 'redux-logic'
import handleErrors from '@app/helpers/handleErrors'
import sortDevicesGroups from '@app/helpers/scenes/sortDevicesGroups'
import { SYNC_ZWAVE_DEVICES_BY_GROUPS } from '@app/constants/scenes/zWaveDevices/zWaveDevicesByGroups'
import { updateZWaveDevicesByGroups } from '@app/actions/scenes/zWaveDevices/zWaveDevicesByGroups'
import fetchZWaveDevicesByGroups from '@app/api/scenes/ZWaveDevices/fetchZWaveDevicesByGroups'
import { API_REQUEST_CANCEL } from '@app/constants/apiRequest'
import { apiRequestSent, apiRequestDone, apiRequestFailed } from '@app/actions/apiRequest'

const fetchZWaveDevicesByGroupsLogic = createLogic({
  type: SYNC_ZWAVE_DEVICES_BY_GROUPS,
  cancelType: API_REQUEST_CANCEL,

  process(_, dispatch, done) {
    const { secrets: { accessToken: { token } } } = store.getState()
    dispatch(apiRequestSent(SYNC_ZWAVE_DEVICES_BY_GROUPS))
    fetchZWaveDevicesByGroups(token)
      .then((response) => {
        const { data: { groups } } = response
        const sortedGroups = sortDevicesGroups(groups, 'ZWaveDevices')
        dispatch(updateZWaveDevicesByGroups(sortedGroups))
        dispatch(apiRequestDone(SYNC_ZWAVE_DEVICES_BY_GROUPS))
      })
      .catch((error) => {
        if (error) {
          const currentError = handleErrors(error)
          dispatch(apiRequestFailed(currentError))
        } else {
          throw new Error('fetchZWaveDevicesByGroups failed without error')
        }
      })
      .then(() => done())
  },
})

export default fetchZWaveDevicesByGroupsLogic
